import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { EventEmitter } from '@spotify-internal/emitter';
import { Event } from '../enums/event';
export var ConnectionObserver =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(ConnectionObserver, _EventEmitter);

  function ConnectionObserver(options) {
    var _this;

    _classCallCheck(this, ConnectionObserver);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionObserver).call(this));
    var hasWindow = typeof window !== 'undefined';
    var notifyBeforeUnload = options && options.notifyBeforeUnload;
    _this._navigator = hasWindow && window.navigator || null;

    if (hasWindow && typeof window.addEventListener === 'function') {
      window.addEventListener('online', _this.emitSync.bind(_assertThisInitialized(_this), Event.CONNECTION_ONLINE, null));
      window.addEventListener('offline', _this.emitSync.bind(_assertThisInitialized(_this), Event.CONNECTION_OFFLINE, null));

      if (notifyBeforeUnload) {
        window.addEventListener(Event.WINDOW_BEFORE_UNLOAD, _this.emitSync.bind(_assertThisInitialized(_this), Event.WINDOW_BEFORE_UNLOAD, null));
      }
    }

    return _this;
  }

  _createClass(ConnectionObserver, [{
    key: "isOnline",
    value: function isOnline() {
      var navigator = this._navigator;

      if (navigator && 'onLine' in navigator) {
        return navigator.onLine;
      }

      return true;
    }
  }], [{
    key: "create",
    value: function create(options) {
      return new ConnectionObserver(options);
    }
  }]);

  return ConnectionObserver;
}(EventEmitter);